type Value = Record<string | number, unknown>;

export const removeEmptyValues = (value: Value) => {
  return Object.fromEntries(Object.entries(value).filter(([, v]) => !!v));
};
